export default __webpack_public_path__ + "static/media/Second Wind.103bb95d.jpg";